import BSAlert from 'react-bootstrap/Alert'
import Card from './Card'
import CombosPanel from './CombosPanel'
import DeckSummaryPanel from './DeckSummaryPanel'
import FilterPanel from './FilterPanel'
import ManaCurvePanel from './ManaCurvePanel'
import NavigationPanel from './NavigationPanel'
import { OutboundLink } from 'react-ga'
import RelatedContentPanel from './RelatedContentPanel'
import TypeDistributionPanel from './TypeDistributionPanel'
import styles from '../styles/Panels.module.scss'
import { useLocation } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Panels = () => {
  const { dir } = useParams()
  const data = useSelector((state) => state.pagedata.data)
  const isLoading = useSelector((state) => state.pagedata.isLoading)
  const { search } = useLocation()

  const card = data?.container?.json_dict?.card
  const cardlists = data?.container?.json_dict?.cardlists
  const comboHeader = data?.container?.comboHeader
  const panels = data?.panels
  const showAdvancedFilters = ['commanders', 'decks'].includes(dir)

  if (dir === 'combos') {
    const comboHeaderCards = isLoading
      ? [...Array(3)].map(() => ({
          isLoading: true,
        }))
      : cardlists
      ? comboHeader.cardviews
      : []
    return (
      <div className={styles.comboHeader}>
        {comboHeaderCards.map((card) => (
          <Card hideName key={card.name} {...card} />
        ))}
      </div>
    )
  }

  const isSoloPartner =
    data?.container.json_dict?.card?.legal_partner &&
    !data?.container.json_dict?.card.cards

  return (
    <div className={styles.container}>
      <div className={styles.panels}>
        {isSoloPartner && (
          <BSAlert variant='warning'>
            This is {data?.container.json_dict?.card.name}{' '}
            <b>with no partner</b>. Select a partner using the Partners
            dropdown.
          </BSAlert>
        )}
        <div className={styles.panelRow}>
          {(card || isLoading) && (
            <div className={styles.panelColLeft}>
              <div className={styles.panelItem}>
                <div className={styles.panelCard}>
                  <Card {...card} hideName isLoading={isLoading} />
                </div>
              </div>
              <div className={styles.panelItem}>
                <NavigationPanel />
              </div>
            </div>
          )}
          <div className='d-flex flex-column'>
            <div className={styles.panelRightHalf}>
              <div className={styles.panelColMid}>
                <div className={styles.panelItem}>
                  {!(dir === 'decks' && search) && (
                    <TypeDistributionPanel
                      {...panels?.piechart}
                      isLoading={isLoading}
                    />
                  )}
                </div>
                {dir === 'commanders' && (
                  <div className={styles.panelItem}>
                    <ManaCurvePanel
                      curve={panels?.mana_curve}
                      isLoading={isLoading}
                    />
                  </div>
                )}
              </div>
              <div className={styles.panelColRight}>
                <div className={styles.panelItem}>
                  {data.coalesce ? (
                    <div>
                      <h5 className='title'>{data.coalesce.product_name}</h5>
                      <OutboundLink
                        eventLabel={data.coalesce.product_url}
                        rel='noopener noreferrer'
                        target='_blank'
                        to={data.coalesce.product_url}
                      >
                        <img
                          alt={data.coalesce.product_name}
                          style={{ maxWidth: '100%' }}
                          src={data.coalesce.image}
                        />
                      </OutboundLink>
                    </div>
                  ) : (
                    <RelatedContentPanel
                      articles={panels?.articles}
                      isLoading={isLoading}
                      relatedVideo={panels?.related_video}
                      showAdvancedFilters={showAdvancedFilters}
                    />
                  )}
                </div>
                {showAdvancedFilters && (
                  <div className={styles.panelItem}>
                    <FilterPanel />
                  </div>
                )}
                {dir === 'deckpreview' && (
                  <div className={styles.panelItem}>
                    <DeckSummaryPanel />
                  </div>
                )}
              </div>
            </div>
            {card?.combos && !card?.is_partner && (
              <div className={styles.panelRow}>
                <div className={styles.panelItem}>
                  <CombosPanel card={card} combos={panels.combocounts} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Panels
